/**
 * A mapping of link types to matching selectors. Links clicked will be
 * compared against these selectors and assigned a type. These types have
 * been determined based on requirements from event handlers utilizing
 * this decorator ie. DTM and FPS.
 */
const linkTypeSelectors = {
	// probably we can't really change these first ones, many account overrides:
	'ford-parts-page-enrolled': [
		'.alias-commodity-page-parts [data-widget-id="ownership-hero"] a[href*="parts.ford.com/?dealer_id"]'
	],
	'ford-parts-page-not-enrolled': [
		'.alias-commodity-page-parts [data-widget-id="ownership-hero"] a[href="https://parts.ford.com/"]'
	],
	'ford-blue-advantage-search-download-gold': [
		'[data-tracking-label="blue-advantage-gold"]'
	],
	'ford-blue-advantage-search-download-blue': [
		'[data-tracking-label="blue-advantage-blue"]'
	],
	'ford-blue-advantage-search-download-172': [
		'[data-tracking-label="blue-advantage-172"]'
	],
	'ford-blue-advantage-search-download-139': [
		'[data-tracking-label="blue-advantage-139"]'
	],
	// have not found example, seems outdated?
	'fordprotect-page-download-premium-care': [
		'.alias-fordprotect-page [href="https://images.dealer.com/ddc/ford/fordprotect/PremiumCARE_Bro_2021.pdf"]'
	],
	'fordprotect-page-download-premium-maintenance': [
		'.alias-fordprotect-page [href="https://images.dealer.com/ddc/ford/fordprotect/PremiumMaintenance_Bro_2021.pdf"]'
	],
	'fordprotect-page-download-premiumcare-brochure': [
		'[data-tracking-label="premiumcare-brochure"]'
	],
	'fordprotect-page-download-premium-maintenance-brochure': [
		'[data-tracking-label="maintenance-brochure"]'
	],
	'fordprotect-page-download-premiumcare-ev-brochure': [
		'[data-tracking-label="premiumcare-ev-brochure"]'
	],
	'fordprotect-page-download-premium-maintenance-ev-brochure': [
		'[data-tracking-label="maintenance-ev-brochure"]'
	],
	// ford ev landing page
	'alias-sitebuilder-electric-vehicles-1-range-and-batteries': [
		'.alias-sitebuilder-electric-vehicles-1 .range-and-batteries a'
	],
	'alias-sitebuilder-electric-vehicles-1-make-the-switch': [
		'.alias-sitebuilder-electric-vehicles-1 .make-the-switch a'
	],
	'alias-sitebuilder-electric-vehicles-1-make-the-switch-content-area': [
		'.alias-sitebuilder-electric-vehicles-1 .make-the-switch-content-area'
	],
	'alias-sitebuilder-electric-vehicles-1-home-charging': [
		'.alias-sitebuilder-electric-vehicles-1 .home-charging a'
	],
	'alias-sitebuilder-electric-vehicles-1-public-charging': [
		'.alias-sitebuilder-electric-vehicles-1 .public-charging a'
	],
	'alias-sitebuilder-electric-vehicles-1-bluecruise-learn-more': [
		'.alias-sitebuilder-electric-vehicles-1 .bluecruise-learn-more a'
	],
	'alias-sitebuilder-electric-vehicles-1-schedule-service': [
		'.alias-sitebuilder-electric-vehicles-1 .schedule-service'
	],
	'alias-sitebuilder-electric-vehicles-1-maintenance-guides': [
		'.alias-sitebuilder-electric-vehicles-1 .maintenance-guides'
	],
	'alias-sitebuilder-electric-vehicles-1-discover-fordpass-app': [
		'.alias-sitebuilder-electric-vehicles-1 .discover-fordpass-app a'
	],
	'alias-sitebuilder-electric-vehicles-1-explore-owner-support': [
		'.alias-sitebuilder-electric-vehicles-1 .explore-owner-support a'
	],
	'alias-sitebuilder-electric-vehicles-1-bluecruise-content-area': [
		'.alias-sitebuilder-electric-vehicles-1 .bluecruise-content-area a'
	],
	// incentive examples in nonprod would be useful:
	incentive: [
		'a[data-incentive-id]',
		'a[href*="/global-incentives/request-form.htm"]',
		'.vehicle-card dl.pricing-detail [role="button"]',
		'.vehicle-card dl.pricing-detail dt .text-link',
		'.vehicle-card .wsm-incentive-display .text-link'
	],
	// Special examples in nonprod would be usful:
	'specials-emailafriend': ['a[href*="/specials/emailafriend-form.htm"]'],
	'specials-inforequest': ['a[href*="/specials/inforequest-form.htm"]'],
	'video-popup': [
		'.hproduct .media .video',
		'#ddc-mobile-vlp-inventory .hproduct .media a[href*="vid"]',
		'#compareForm .hproduct .media .video',
		'.vehicle-card .vehicle-card-media-container .open-media-modal-btn'
	],
	'video-tab': ['.inventory-detail-media-tabs a[href="#video"]'],
	// maybe we should modify ws-inv-listing:
	'windowsticker-vlp': [
		'.srp a[href*="windowsticker"]',
		'.srp a[href*="WindowSticker"]'
	],
	// not finding windowsticker in np:
	'windowsticker-vdp': [
		'.window-sticker-link',
		'.vdp .windowsticker a',
		'.vdpCTA .window-sticker-img-2',
		'.vdp a[href*="windowsticker"]',
		'.vdp a[href*="WindowSticker"]'
	],
	// not finding links in np:
	'models-brochures': [
		'.alias-models #model-selector-default a[href*="/services/assets/Brochure"]'
	],
	'collision-page-link': [
		'a.collision[href*=".pdf"]',
		'a.collision-link[href="#rights-section"]',
		'a.collision-link[href="#why-choose-section"]'
	],
	// no single place where to modify this one:
	'ford-download': [
		'.ford a[href*=".pdf"]',
		'a[href*="/services/assets/Brochure"]'
	],
	'special-offers-print': [
		'.alias-specials-listing-service a[href*="/specials/service-print.htm"]'
	],
	// not true links:
	'slideshow-prev': ['.previousNext a.prev'],
	'slideshow-next': ['.index a.next'],
	'vdp-slideshow': ['.photo-carousel button.btn-carousel.btn'],
	pager: ['.index .pager a'],
	'scroll-left-lincoln-aviator-gas-gallery': [
		'.alias-why-buy-aviator .main-gallery .pswp__scroll-wrap .pswp__button.pswp__button--arrow--left'
	],
	'scroll-right-lincoln-aviator-gas-gallery': [
		'.alias-why-buy-aviator .main-gallery .pswp__scroll-wrap .pswp__button.pswp__button--arrow--right'
	],
	'lincoln-aviator-test-drive': ['.tracking-link-testdrive'],

	// *********************************************************************************************************
	// *********************************************************************************************************
	// *********************************************************************************************************
	// RECENT NOTES!!! July 19th 2024 - Timothy Burgher
	// THE FOLLOWING SECTION IS ALL MIGRATED USING ws-media-viewer widget user events in forddirectnative
	// No need for link mapping on this section
	// https://www.bigcountrymotorslincoln.com/lincoln-aviator-phev.htm
	// SITEBUILDER_2023_LINCOLN_AVIATOR_1
	// MIGRATED
	'lincoln-aviator-ev-gallery-scroll-left': [
		// WUE for left arrow button click on modal
		'.alias-sitebuilder-2023-lincoln-aviator-1 [data-widget-name="ws-media-viewer"] .pswp__scroll-wrap .pswp__button.pswp__button--arrow--left'
	],
	// MIGRATED
	'lincoln-aviator-ev-gallery-scroll-right': [
		// WUE for right arrow button click on modal
		'.alias-sitebuilder-2023-lincoln-aviator-1 [data-widget-name="ws-media-viewer"] .pswp__scroll-wrap .pswp__button.pswp__button--arrow--right'
	],
	// MIGRATED
	'lincoln-aviator-ev-gallery': [
		// WUE when you click the thumbnail to open the modal
		'.alias-sitebuilder-2023-lincoln-aviator-1 [data-widget-name="ws-media-viewer"] .gallery.grid.large.row-items-fluid .layout.grid a'
	],
	// MIGRATED
	'why-buy-gallery': [
		// WHY_BUY_NAUTILUS_2023
		// WUE when you click the thumbnail to open the modal
		'.alias-why-buy-nautilus-2023 .ws-media-viewer a'
	],
	// WHY_BUY_NAVIGATOR_2023
	// https://lincolnprofilev9.cms.dealer.com/2023-lincoln-navigator.htm
	// MIGRATED
	'why-buy-navigator-2023-gallery-ext': [
		'.alias-why-buy-navigator-2023 [data-widget-id="content9"] .layout'
	],
	// WHY_BUY_NAVIGATOR_2023
	// https://lincolnprofilev9.cms.dealer.com/2023-lincoln-navigator.htm
	// MIGRATED
	'why-buy-navigator-2023-gallery-int': [
		'.alias-why-buy-navigator-2023 [data-widget-id="content11"] .layout'
	],
	// MIGRATED
	'why-buy-nautilus-2023-gallery': [
		// WHY_BUY_NAUTILUS_2023
		'.alias-why-buy-nautilus-2023 .ws-media-viewer a', // WUE thumbnail that opens modal
		'.alias-why-buy-nautilus-2023 .ws-media-viewer .layout' // not sure why we are monitoring clicks on the layout div, can prob ignore
	],
	// MIGRATED
	'why-buy-aviator-phev-gallery': [
		// SITEBUILDER_2023_LINCOLN_AVIATOR_1
		'.alias-sitebuilder-2023-lincoln-aviator-1 .ws-media-viewer a',
		'.alias-sitebuilder-2023-lincoln-aviator-1 .ws-media-viewer .layout'
	],
	// MIGRATED
	'why-buy-corsair-2023-gallery': [
		// SITEBUILDER_2023_LINCOLN_CORSAIR_1
		'.alias-sitebuilder-2023-lincoln-corsair-1 .ws-media-viewer a',
		'.alias-sitebuilder-2023-lincoln-corsair-1 .ws-media-viewer .layout'
	],
	// MIGRATED
	'why-buy-corsair-phev-2023-gallery': [
		// SITEBUILDER__2023_LINCOLN_CORSAIR_PHEV_1
		// https://www.cumminslincoln.com/lincoln-corsair-PHEV.htm
		'.alias-sitebuilder--2023-lincoln-corsair-phev-1 .ws-media-viewer a',
		'.alias-sitebuilder--2023-lincoln-corsair-phev-1 .ws-media-viewer .layout'
	],
	// END ws-media-viewer SECTION that has been migrated
	// *********************************************************************************************************
	// *********************************************************************************************************
	// *********************************************************************************************************

	'finance-center': [
		'.alias-sitebuilder-financecenter-1 a[href*="content1-tab-"]',
		'.alias-sitebuilder-financecenter-1 a[href*="content1-panel-"]'
	],
	'black-label-test-drive-navigator-click': [
		'.page-section.row [data-name="empty-one-10"] a[href*="/testdrive/form.htm?parentPageAlias=SITEBUILDER_LINCOLN_BLACK_LABEL_"]'
	],
	'black-label-test-drive-aviator-click': [
		'.page-section.row [data-name="empty-one-12"] a[href*="/testdrive/form.htm?parentPageAlias=SITEBUILDER_LINCOLN_BLACK_LABEL_"]'
	],
	'black-label-test-drive-nautilus-click': [
		'.page-section.row [data-name="empty-one-14"] a[href*="/testdrive/form.htm?parentPageAlias=SITEBUILDER_LINCOLN_BLACK_LABEL_"]'
	],
	'black-label-test-drive-submit': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="inventory-lead1"] .form-default button.btn.btn-primary.ui-button-submit'
	],
	'black-label-navigator-themekit-learn-more': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links3"] a[href="#navigator"]'
	],
	'black-label-nautilus-themekit-learn-more': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links4"] a[href="#nautilus"]'
	],
	'black-label-aviator-themekit-learn-more': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links2"] a[href="#aviator"]'
	],
	'black-label-navigator-invitation-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow3"] .slideControls a'
	],
	'black-label-navigator-centralpark-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow4"] .slideControls a'
	],
	'black-label-navigator-yachtclub-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow2"] .slideControls a'
	],
	'black-label-navigator-chalet-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow1"] .slideControls a'
	],
	'black-label-aviator-flight-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow9"] .slideControls a'
	],
	'black-label-aviator-destination-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow5"] .slideControls a'
	],
	'black-label-aviator-chalet-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow8"] .slideControls a'
	],
	'black-label-nautilus-redwood-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow7"] .slideControls a'
	],
	'black-label-nautilus-chalet-theme-iball-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="slideshow6"] .slideControls a'
	],
	'black-label-search-inventory-click': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links1"] a[href*="/new-inventory"]'
	],
	'black-label-search-inventory-click-navigator': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links5"] a[href*="/new-inventory"]'
	],
	'black-label-search-inventory-click-aviator': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links6"] a[href*="/new-inventory"]'
	],
	'black-label-search-inventory-click-nautilus': [
		'.alias-sitebuilder-lincoln-black-label-2 [data-widget-id="links7"] a[href*="/new-inventory"]'
	],
	/* FORD OR LINCOLN */
	// the third of following instances could be modified with a class:
	'apply-battery': [
		'.alias-commodity-page-battery a[href*="citibankonline"]',
		'.alias-commodity-page-battery a[href*="ford-service-credit-card"]',
		'.alias-commodity-page-battery #content-cta-fordpass-button'
	],
	'apply-brakes': [
		'.alias-commodity-page-brakes a[href*="citibankonline"]',
		'.alias-commodity-page-brakes a[href*="ford-service-credit-card"]',
		'.alias-commodity-page-brakes #content-cta-fordpass-button'
	],
	'apply-general': [
		'.alias-commodity-page-service a[href*="citibankonline"]',
		'.alias-commodity-page-general-service  a[href*="ford-service-credit-card"]',
		'.alias-commodity-page-general-service #content-cta-fordpass-button'
	],
	'apply-oil': [
		'.alias-commodity-page-oil a[href*="citibankonline"]',
		'.alias-commodity-page-oil a[href*="ford-service-credit-card"]',
		'.alias-commodity-page-oil #content-cta-fordpass-button'
	],
	'apply-tires': [
		'.alias-commodity-page-tires a[href*="citibankonline"]',
		'.alias-commodity-page-tires a[href*="ford-service-credit-card"]',
		'.alias-commodity-page-tires #content-cta-fordpass-button'
	],
	'blog-post-tag': ['.alias-blog-post-detail .blog-tag-cloud > a'],
	'blog-list-tag': ['.blog-tag-cloud > a'],
	'coupon-scroll-battery': [
		'.alias-commodity-page-battery button.slick-arrow'
	],
	'coupon-scroll-brakes': ['.alias-commodity-page-brakes button.slick-arrow'],
	'coupon-scroll-general': [
		'.alias-commodity-page-general-service button.slick-arrow',
		'.alias-commodity-page-service button.slick-arrow'
	],
	'coupon-scroll-oil': ['.alias-commodity-page-oil button.slick-arrow'],
	'coupon-scroll-tires': ['.alias-commodity-page-tires button.slick-arrow'],
	'inventory-compare-remove': ['.inventory-compare-default .remove'],
	'print-battery': ['.alias-commodity-page-battery a.print-coupon'],
	'print-brakes': ['.alias-commodity-page-brakes a.print-coupon'],
	'print-general': [
		'.alias-commodity-page-general-service a.print-coupon',
		'.alias-commodity-page-service a.print-coupon'
	],
	'print-oil': ['.alias-commodity-page-oil a.print-coupon'],
	'print-tires': ['.alias-commodity-page-tires a.print-coupon'],
	'schedule-battery': [
		'.alias-commodity-page-battery a[href*="/service-appointment.htm"]'
	],
	'schedule-brakes': [
		'.alias-commodity-page-brakes a[href*="/service-appointment.htm"]'
	],
	'schedule-general': [
		'.alias-commodity-page-general-service a[href*="/service-appointment.htm"]',
		'.alias-commodity-page-service a[href*="/service-appointment.htm"]'
	],
	'schedule-oil': [
		'.alias-commodity-page-oil a[href*="/service-appointment.htm"]'
	],
	'schedule-tires': [
		'.alias-commodity-page-tires a[href*="/service-appointment.htm"]'
	],
	'shop-accessories': [
		'.accessories-page a[data-tracking="shop-accessories"]'
	],
	// the data-tracking attribute is added in dvs at fordprofile/labels on ACCESSORIES_PAGE_HERO_CONTENT.
	// This is because it's in the content of a hero widget.
	'accessorize-my-ford': [
		'.accessories-page a[data-tracking="accessorize-my-ford"]'
	],
	// not found dollowing instances, outdated?
	'shop-interior': ['.accessories-page a[id="content-cta1-button"]'],
	'shop-wheels': ['.accessories-page a[id="content-cta2-button"]'],
	'shop-electronics': ['.accessories-page a[id="content-cta3-button"]'],
	'shop-bed-products': ['.accessories-page a[id="content-cta4-button"]'],
	'shop-exterior-products': ['.accessories-page a[id="content-cta5-button"]'],
	'shop-trailer-towing': ['.accessories-page a[id="content-cta6-button"]'],
	'shop-apply-now': ['.accessories-page a[id="content-cta7-button"]'],
	// could be solved adding class to buttons:
	'ford-pass-learn-more': [
		'.fordpass-rewards-page a[id="content-cta1-button"]'
	],
	'ford-pass-faq': ['.fordpass-rewards-page a[id="content-cta8-button"]'],
	'ford-adchoices': ['a[href*="https://www.forddirect.com/adchoices"]'],
	'ford-pass-learn-about-the-app': [
		'.alias-adops-why-buy-ford-pass .learn-about-fordpass-app',
		'.alias-sitebuilder-fordpass-2022-1 .learn-about-fordpass-app'
	],
	'ford-pass-learn-about-the-rewards': [
		'.alias-adops-why-buy-ford-pass .learn-about-fordpass-rewards',
		'.alias-sitebuilder-fordpass-2022-1 .learn-about-fordpass-rewards'
	],
	'ford-pass-learn-about-the-rewards-visa': [
		'.alias-sitebuilder-fordpass-2022-1 .learn-about-fordpass-rewards-visa'
	],
	'ev-lightning-learn-more': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .learn-more'
	],
	'ev-lightning-view-inventory': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .view-inventory'
	],
	'ev-lightning-schedule-a-test-drive': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .schedule-a-test-drive'
	],
	'ev-lightning-search-inventory': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .search-inventory'
	],
	'ev-lightning-charging-info': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .charging-info'
	],
	'ev-lightning-explore-home-charging': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .explore-home-charging'
	],
	'ev-lightning-explore-power': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .explore-power'
	],
	'ev-lightning-explore-public-charging': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .explore-public-charging'
	],
	'ev-lightning-explore-see-how-much-you-could-save': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .see-how-much-you-could-save'
	],
	'ev-lightning-explore-contact-us': [
		'.alias-sitebuilder-ford-f-150-lightning-1 .explore-contact-us'
	],
	'ev-charging-cta-explore-incentives': [
		'.alias-sitebuilder-ev-charging-1 .explore-incentives'
	],
	'ev-charging-see-how-much-you-could-save': [
		'.alias-sitebuilder-ev-charging-1 .see-how-much-you-could-save'
	],
	'ev-charging-get-more-charging-info': [
		'.alias-sitebuilder-ev-charging-1 .get-more-charging-info'
	],
	'ev-charging-see-our-multi-point-checklist': [
		'.alias-sitebuilder-ev-charging-1 .see-our-multi-point-checklist'
	],
	'ev-fake-thing': ['.fake-thing'],
	'ev-overview-explore-incentives': [
		'.alias-sitebuilder-ev-overview-1 [data-widget-id="links2"] .explore-incentives'
	],
	'ev-overview-explore-charging': [
		'.alias-sitebuilder-ev-overview-1 [data-widget-id="links3"] .explore-charging'
	],
	'ev-overview-explore-cta-f150': [
		'.alias-sitebuilder-ev-overview-1 [data-widget-id="links5"] .test-drive-an-f150-lightning'
	],
	'ev-overview-explore-cta-mache': [
		'.alias-sitebuilder-ev-overview-1 [data-widget-id="links4"] .test-drive-a-mustang-mache'
	],
	'ev-overview-see-how-much-you-could-save': [
		'.alias-sitebuilder-ev-overview-1 [data-widget-id="links7"] .see-how-much-you-could-save'
	],
	'ev-overview-get-more-ownership-info': [
		'.alias-sitebuilder-ev-overview-1 [data-widget-id="links8"] .get-more-ownership-info'
	],
	'ev-overview-contact-us': [
		'.alias-sitebuilder-ev-overview-1 [data-widget-id="links9"] .contact-us'
	],
	'ev-overview-all-incentives': [
		'.alias-sitebuilder-ev-overview-1 .ev-overview-all-incentives'
	],
	'ford-mobile-learn-more': [
		'.alias-sitebuilder-ford-mobile-service-1 .rewards-overview'
	],
	'alias-sitebuilder-2023-ford-mach-e-1-fuel-economy-gov': [
		'.alias-sitebuilder-2023-ford-mach-e-1 .fuel-economy-gov'
	],
	'alias-sitebuilder-2023-ford-mach-e-1-schedule-a-test-drive': [
		'.alias-sitebuilder-2023-ford-mach-e-1 .schedule-a-test-drive'
	],
	'alias-sitebuilder-2023-ford-mach-e-1-get-more-charging-info': [
		'.alias-sitebuilder-2023-ford-mach-e-1 .get-more-charging-info'
	],
	'alias-sitebuilder-2023-ford-mach-e-1-view-details': [
		'.alias-sitebuilder-2023-ford-mach-e-1 .inventory-featured-default .view-link'
	],
	'ncc-vinless-card-mache': [
		'.ford .ws-inv-listing a[href*="t3-modele-srp-vinless-mache"]'
	],
	'ncc-vinless-card-lightning': [
		'.ford .ws-inv-listing a[href*="t3-modele-srp-vinless-lightning"]'
	],
	// this one is also at account level:
	'staff-click': ['#staffList a'],
	'finance-application': [
		'.alias-finance-application .finance-application .btn-primary',
		'.alias-finance-application .finance-application a[href*="#finance-application"]',
		'.alias-finance-application .finance-application a[href*="#fordprofile_finance_application"]'
	],
	'black-label-pager': ['.alias-black-label .pager a'],
	'payment-calculator': [
		'.vdp .payment-summary .btn',
		'.vdp .payment-calculator-wrapper .btn',
		'.vdp .ws-detailed-pricing .btn'
	],
	'ford-pass-apple-app-top': [
		'.alias-adops-why-buy-ford-pass .app-link a[href*="apps.apple.com"]',
		'.alias-commodity-page-ford-pass .app-link a[href*="apps.apple.com"]',
		'.ford #page-body .page-section ~ .page-section:nth-child(-n+4) a[href*="apps.apple.com"]'
	],
	'ford-pass-android-app-top': [
		'.alias-adops-why-buy-ford-pass .app-link a[href*="play.google.com"]',
		'.alias-commodity-page-ford-pass .app-link a[href*="play.google.com"]',
		'.ford #page-body .page-section ~ .page-section:nth-child(-n+4) a[href*="play.google.com"]'
	],
	'ford-pass-apple-app-bottom': [
		'.alias-adops-why-buy-ford-pass .app-rewards a[href*="apps.apple.com"]',
		'.alias-commodity-page-ford-pass .app-rewards a[href*="apps.apple.com"]',
		'.ford #page-body .page-section ~ .page-section:nth-child(n+5) a[href*="apps.apple.com"]'
	],
	'ford-pass-android-app-bottom': [
		'.alias-adops-why-buy-ford-pass .app-rewards a[href*="play.google.com"]',
		'.alias-commodity-page-ford-pass .app-rewards a[href*="play.google.com"]',
		'.ford #page-body .page-section ~ .page-section:nth-child(n+5) a[href*="play.google.com"]'
	],
	'ford-blue-advantage-search-inventory': [
		'.alias-certified-pre-owned-vehicles #content1-button'
	],
	'lincoln-cpo-mbg-download': [
		'.alias-sitebuilder-lincoln-certified-preowned-2022-1 .lincoln-cpo-mbg-download'
	],
	'lincoln-cpo-mbg-general-click': [
		'.alias-sitebuilder-lincoln-certified-preowned-2022-1 .lincoln-cpo-mbg-general-click'
	],
	'lincoln-cpo-download': [
		'.alias-certified-pre-owned-vehicles [data-link-label="DOWNLOAD_200_POINT_INSPECTION"]'
	],
	'lincoln-cpo-overview-general-click': [
		'.lincoln.alias-certified-pre-owned-vehicles .links-list .wb-btn',
		'.lincoln.alias-certified-pre-owned-vehicles .links-list .btn-primary',
		'.lincoln.alias-certified-pre-owned-vehicles .links-list .text-capitalize:not([data-link-label="DOWNLOAD_200_POINT_INSPECTION"])'
	],
	'ford-service-price-see-pricing': [
		'.alias-sitebuilder-maintenance-pricing-you-can-trust-1 [data-widget-id="links1"] a[href*="#spt-app"]'
	],
	'ford-service-price-schedule-service': [
		'.alias-sitebuilder-maintenance-pricing-you-can-trust-1 [data-widget-id="links1"] a[href*="/service-appointment.htm"]'
	],
	'ford-service-price-see-all-offers': [
		'.alias-sitebuilder-maintenance-pricing-you-can-trust-1 [data-widget-id="links1"] a[href*="/parts-service-coupons/index.htm"]'
	],
	'ford-service-price-oil-changes': [
		'.alias-sitebuilder-maintenance-pricing-you-can-trust-1 [data-widget-id="content5"] a[href*="/oil-change-advice.htm"]'
	],
	'ford-service-price-tires': [
		'.alias-sitebuilder-maintenance-pricing-you-can-trust-1 [data-widget-id="content6"] a[href*="/tire-care-advice.htm"]'
	],
	'ford-service-price-battery': [
		'.alias-sitebuilder-maintenance-pricing-you-can-trust-1 [data-widget-id="content3"] a[href*="/battery-service-advice.htm"]'
	],
	'ford-service-price-breaks': [
		'.alias-sitebuilder-maintenance-pricing-you-can-trust-1 [data-widget-id="content4"] a[href*="/brake-service-advice.htm"]'
	],
	'lincoln-competitve-compare-navigator-search': [
		'.alias-competitive-comparison-navigator [data-widget-id="hero1"] .btn-primary',
		'.alias-competitive-comparison-navigator [data-name="comparison-links-1"] a[href*="inventory"]'
	],
	'lincoln-competitve-compare-navigator-more': [
		'.alias-competitive-comparison-navigator [data-name="comparison-links-1"] a[href*="lincoln-navigator"]'
	],
	'lincoln-competitve-compare-corsair-search': [
		'.alias-competitive-comparison-corsair .hero-content-background .btn-primary',
		'[data-tracking-label="comparison-corsair-inventory"]'
	],
	'lincoln-competitve-compare-corsair-more': [
		'[data-tracking-label="comparison-corsair-more-about"]'
	],
	'lincoln-competitive-compare-nautilus-search': [
		'.alias-competitive-comparison-nautilus .main a[href*="new-inventory"]'
	],
	'lincoln-competitive-compare-nautilus-more': [
		'.alias-competitive-comparison-nautilus [data-widget-id="links1"] a[href*="lincoln-nautilus"]'
	],
	'lincoln-competitve-compare-aviator-search': [
		'.alias-competitive-comparison [data-widget-id="hero1"] .btn-primary',
		'.alias-competitive-comparison [data-widget-id="links1"] a[href*="inventory"]'
	],
	'lincoln-competitve-compare-aviator-more': [
		'.alias-competitive-comparison [data-widget-id="links1"] a[href*="lincoln-nautilus"]'
	],
	'ford-mobile-service': [
		'.alias-sitebuilder-ford-mobile-service-1 .schedule-service a'
	],
	schedule_delivery_1: [
		'.alias-sitebuilder-ford-pickup-and-delivery-1 [href*="/service-appointment.htm"]'
	],
	accordion_delivery_1: [
		'.alias-sitebuilder-ford-pickup-and-delivery-1 [data-widget-id*="accordion-content1"] a'
	],
	'model-e-buy-now-srp': [
		'.srp [data-web-api-id="forddirect-add-model-e-cta-to-vdp"] .btn'
	],
	'model-e-buy-now-vdp': [
		'.vdp [data-web-api-id="forddirect-add-model-e-cta-to-vdp"] .btn'
	],
	'pickup-and-delivery-cta': [
		'.alias-pickup-and-delivery .btn[data-form-id="service1"]'
	],

	// KEEP AT BOTTOM
	referral: [
		'a[href*="ford.com"]',
		'a[href*="lincoln.com"]',
		'a[href*="forddirect.com"]',
		'a[href*="forddirectprivacy.com"]'
	]
};

export default linkTypeSelectors;
